$(document).ready(function () {
  $('.box-list').masonry();

  // window.addEventListener('resize', function () {
  //     $('.box-list').masonry({
  //         itemSelector: '.box-item',
  //         columnWidth: (window.screen.width >= 1921) ? 280 : 250,
  //         gutter: 60,
  //     });
  // });
});